import { CaseState } from 'app/area/case/types-store';

export function changeCaseSequence(caseState: CaseState, uiEngineProps: any) {
  const caseId = Number(Object.keys(caseState.stateForCaseIds || {})
    .find(key => caseState.stateForCaseIds?.[key]?.changeConnectionSequence?.caseId));
  const changeConnectionSequence = caseState.stateForCaseIds?.[caseId]?.changeConnectionSequence;
  
  if (!caseId || !changeConnectionSequence) {
    return {};
  }

  return {
    changeConnectionSequence: {
      caseId,
      fetching: changeConnectionSequence?.fetching,
      responseWarning: changeConnectionSequence?.responseWarning
    }
  };
}
